import { render, staticRenderFns } from "./ColumnSeries.vue?vue&type=template&id=68a516fa&scoped=true"
import script from "./ColumnSeries.vue?vue&type=script&lang=js"
export * from "./ColumnSeries.vue?vue&type=script&lang=js"
import style0 from "./ColumnSeries.vue?vue&type=style&index=0&id=68a516fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a516fa",
  null
  
)

export default component.exports